export default __webpack_public_path__ + "static/apple-wallet-hero-bf1bd8aac6709f95cf4c8b4809f30fcb.png";